import getColor from "@insite/mobius/utilities/getColor";
import { accountSettingsDefaultBillingShippingStyles } from "@waytek/Overrides/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

accountSettingsDefaultBillingShippingStyles.defaultBillingShippingWrapper = {
    ...accountSettingsDefaultBillingShippingStyles.defaultBillingShippingWrapper,
    css: css`
        ${mediaQueriesBP.minLG} {
            width: calc(100% + 10px);
        }

        ${mediaQueriesBP.minMD} {
            padding-left: 20px;
        }

        ${mediaQueriesBP.maxMD} {
            margin-top: 40px;
        }
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle = {
    ...accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle,
    variant: "h6",
    as: "h2",
    css: css`
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.78;
        letter-spacing: normal;
        border-bottom: 3px solid ${getColor("common.global.industrialTaupe")};
        margin-bottom: 20px;
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultBillingShippingMessage = {
    ...accountSettingsDefaultBillingShippingStyles.defaultBillingShippingMessage,
    size: 14,
    css: css`
        margin-bottom: 10px;
        display: block;
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGroup = {
    ...accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGroup,
    css: css`
        margin-bottom: 10px;
    `,
};

accountSettingsDefaultBillingShippingStyles.customerSelectorGridContainer = {
    ...accountSettingsDefaultBillingShippingStyles.customerSelectorGridContainer,
    css: css`
        margin-left: 0;
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridItem = {
    ...accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridItem,
    css: css`
        &&& {
            width: 100%;
            margin: 0;
            padding: 0;
        }
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridContainer = {
    ...accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridContainer,
    css: css`
        &&& {
            width: 100%;
            margin: 0;

            & > div {
                width: 100%;
                margin: 0;
            }
        }
    `,
};
